/* Wishanart product page behaviour. Reads the variants JSON emitted by sections/main-product.liquid.
   1 variant picker (size buttons + mount cards) -> hidden id, price, sticky bar, availability
   2 in / cm toggle (remembered)  3 Order on WhatsApp names the chosen size + mount
   4 fit-compare table follows the chosen size  5 spec tooltip  6 sticky column fit
   7 Razorpay EMI widget redraws per variant (harmless when no Razorpay script is on the page) */
(function () {
  var cfgEl = document.querySelector('[data-wa-variants]');
  if (!cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var form = document.getElementById(cfg.form);
  if (!form) return;
  var variants = cfg.variants || [];
  var rows = form.querySelectorAll('[data-option-row]');
  var hiddenId = form.querySelector('[data-variant-id]');
  var priceEl = form.querySelector('[data-pdp-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var afterBox = form.querySelector('[data-pdp-after]'), afterEl = form.querySelector('[data-pdp-after-v]');
  var afterPct = afterBox ? +afterBox.getAttribute('data-pct') || 0 : 0;
  var optCount = variants.length ? variants[0].options.length : 0;
  var selected = new Array(optCount);

  /* 1 picker */
  rows.forEach(function (row) {
    var a = row.querySelector('.opt.active') || row.querySelector('.opt');
    if (a) selected[+a.dataset.optionIndex] = a.dataset.optionValue;
  });
  function find() {
    for (var k = 0; k < variants.length; k++) {
      var v = variants[k], ok = true;
      for (var i = 0; i < optCount; i++) if (v.options[i] !== selected[i]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function refresh(byUser) {
    var v = find(); if (!v) return;
    if (hiddenId) hiddenId.value = v.id;
    if (priceEl) priceEl.textContent = v.priceText;
    if (afterEl && afterPct) { var ap = Math.floor(v.price * (100 - afterPct) / 100); afterEl.textContent = '₹' + (ap / 100).toLocaleString('en-IN', { minimumFractionDigits: ap % 100 ? 2 : 0, maximumFractionDigits: 2 }); }
    if (stickyPrice) stickyPrice.textContent = (cfg.onlyDefault ? '' : v.title + ' · ') + v.priceText;
    rows.forEach(function (row) {
      row.querySelectorAll('.opt').forEach(function (btn) {
        var i = +btn.dataset.optionIndex, val = btn.dataset.optionValue;
        var ok = variants.some(function (c) {
          if (!c.available || c.options[i] !== val) return false;
          for (var j = 0; j < optCount; j++) if (j !== i && selected[j] && c.options[j] !== selected[j]) return false;
          return true;
        });
        btn.classList.toggle('unavailable', !ok);
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    });
    form.querySelectorAll('button[name="add"]').forEach(function (b) { b.disabled = !v.available; });
    if (byUser) try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    syncWa(v); syncTable(); emiSchedule();
  }
  rows.forEach(function (row) {
    row.querySelectorAll('.opt').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        row.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('active'); btn.setAttribute('aria-pressed', 'true');
        selected[+btn.dataset.optionIndex] = btn.dataset.optionValue;
        refresh(true);
      });
    });
  });

  /* 2 unit toggle */
  var KEY = 'wa-size-unit';
  function applyUnit(unit) {
    document.querySelectorAll('[data-size-text]').forEach(function (el) {
      var t = unit === 'cm' ? el.getAttribute('data-cm') : el.getAttribute('data-in');
      if (t) el.textContent = t;
    });
    document.querySelectorAll('[data-unit-toggle] .unit').forEach(function (b) {
      var on = b.dataset.unit === unit; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.documentElement.setAttribute('data-size-unit', unit);
  }
  document.querySelectorAll('[data-unit-toggle]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      var b = e.target.closest('.unit'); if (!b) return;
      try { localStorage.setItem(KEY, b.dataset.unit); } catch (err) {}
      applyUnit(b.dataset.unit);
    });
  });
  var saved = 'in'; try { saved = localStorage.getItem(KEY) || 'in'; } catch (err) {}
  if (saved === 'cm') applyUnit('cm');

  /* 3 WhatsApp order text carries the chosen variant */
  function syncWa(v) {
    var a = document.querySelector('[data-wa-order]'); if (!a || !a.dataset.waNum) return;
    var msg = 'Hi! I\'d like to order "' + a.dataset.waTitle + '"';
    if (v && !cfg.onlyDefault) msg += ' - ' + v.title;
    msg += '. [pdp-order] ' + a.dataset.waUrl + (v && v.id ? '?variant=' + v.id : '');
    a.href = 'https://wa.me/' + a.dataset.waNum + '?text=' + encodeURIComponent(msg);
  }

  /* 4 fit-compare table row follows the chosen size */
  function norm(s) { var m = String(s || '').match(/\d+/g); return m ? m.slice(0, 2).join('x') : ''; }
  function syncTable() {
    if (cfg.sizeIndex < 0) return;
    var table = document.querySelector('.sc-table'); if (!table) return;
    var key = norm(selected[cfg.sizeIndex]); if (!key) return;
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var th = tr.querySelector('th'); tr.classList.toggle('is-on', !!th && norm(th.textContent) === key);
    });
  }

  /* 5 spec tooltip */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('.spec-dot') : null;
    document.querySelectorAll('.spec-info.is-open').forEach(function (box) {
      if (!dot || box !== dot.parentNode) { box.classList.remove('is-open'); var b = box.querySelector('.spec-dot'); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
    if (dot) { e.preventDefault(); var open = dot.parentNode.classList.toggle('is-open'); dot.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.spec-info.is-open').forEach(function (box) { box.classList.remove('is-open'); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href="#find-your-fit"]') : null;
    var t = document.getElementById('find-your-fit');
    if (!a || !t) return;
    e.preventDefault(); t.scrollIntoView({ block: 'start' });
    try { history.replaceState(null, '', location.pathname + location.search + '#find-your-fit'); } catch (err) {}
  });

  /* 6 sticky buy-box column never taller than the viewport */
  var col = document.querySelector('.pdp-info');
  function fit() {
    if (!col) return;
    try {
      if (getComputedStyle(col).position !== 'sticky') return;
      var h = col.getBoundingClientRect().height;
      col.style.setProperty('--pdp-sticky-top', Math.min(96, Math.round(window.innerHeight - 24 - h)) + 'px');
    } catch (e) {}
  }
  var ft; function fitLater() { clearTimeout(ft); ft = setTimeout(fit, 120); }
  fit(); window.addEventListener('resize', fitLater); window.addEventListener('load', fit);
  if (window.ResizeObserver && col) new ResizeObserver(fitLater).observe(col);

  /* 7 Razorpay EMI: Razorpay binds the amount once, so redraw it for the chosen variant. */
  var host = document.querySelector('[data-rzp-widget]');
  var lastAmount = null, et = null;
  function emiAmount() { var v = find(); return v ? v.price : 0; }
  function emiRedraw() {
    if (!host) return;
    try {
      var Suite = window.RazorpayAffordabilitySuite, base = window.rzpAffordabilitySuite;
      var amount = emiAmount(); if (!amount) return;
      host.style.display = amount < cfg.emiMin ? 'none' : '';
      if (!Suite || !base || !base.options || amount < cfg.emiMin || amount === lastAmount) return;
      lastAmount = amount;
      var o = {}; for (var k in base.options) if (Object.prototype.hasOwnProperty.call(base.options, k)) o[k] = base.options[k];
      o.amount = amount; new Suite(o).render();
    } catch (e) {}
  }
  function emiSchedule() { clearTimeout(et); et = setTimeout(emiRedraw, 200); }
  if (host) {
    var tries = 0, w = setInterval(function () {
      tries++;
      if (window.rzpAffordabilitySuite && window.rzpAffordabilitySuite.options) { lastAmount = null; emiRedraw(); clearInterval(w); }
      else if (tries > 60) { clearInterval(w); }
    }, 250);
    host.style.display = emiAmount() < cfg.emiMin ? 'none' : '';
  }

  refresh(false);
})();
